(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /*
     * Pruefung PR #1733: Kommt waehrend eines laufenden Abrufs eine weitere
     * Warenkorbaenderung, gibt der Section-Renderer fuer dieselbe URL die
     * laufende Anfrage zurueck - trotz cache: false - und damit den Stand von
     * vor der Aenderung. Deshalb je Section nur ein Abruf zugleich; weitere
     * Aenderungen werden vorgemerkt und danach mit einem frischen Abruf geholt.
     */
    var laufend = {};
    function neuLaden(renderer, id) {
      if (laufend[id]) {
        laufend[id] = 'nochmal';
        return;
      }
      laufend[id] = 'laeuft';
      renderer
        .renderSection(id, { cache: false })
        .catch(function () {})
        .then(function () {
          var nochmal = laufend[id] === 'nochmal';
          laufend[id] = null;
          if (nochmal) neuLaden(renderer, id);
        });
    }
    document.addEventListener('cart:update', function () {
      var marken = document.querySelectorAll('[data-tp-wk-inhalt]');
      if (!marken.length) return;
      import('@theme/section-renderer')
        .then(function (modul) {
          Array.prototype.forEach.call(marken, function (marke) {
            var id = marke.getAttribute('data-tp-wk-inhalt');
            if (id) neuLaden(modul.sectionRenderer, id);
          });
        })
        .catch(function () {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-boden-auswahl"] && !Shopify.designMode) return;
  try {
    
(() => {
  let controller;
  let version = 0;
  async function refreshSelection() {
    const element = document.querySelector('[data-tp-boden-auswahl]');
    if (!element) return;
    controller?.abort();
    controller = new AbortController();
    const current = ++version;
    const url = new URL(window.location.href);
    url.hash = '';
    url.searchParams.set('section_id', element.dataset.sectionId);
    try {
      const response = await fetch(url.href, { signal: controller.signal });
      if (!response.ok) throw new Error('Bodenauswahl konnte nicht aktualisiert werden');
      const html = await response.text();
      if (current !== version) return;
      const replacement = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-tp-boden-auswahl]');
      if (!replacement) throw new Error('Bodenauswahl fehlt in der Serverantwort');
      element.replaceWith(replacement);
    } catch (error) {
      if (error.name === 'AbortError' || current !== version) return;
      window.location.reload();
    }
  }
  document.addEventListener('filter:update', refreshSelection);
  window.addEventListener('popstate', refreshSelection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-standardteppiche-einstiege"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('filter:update', async () => {
    const navigation = document.querySelector('[data-tp-standardteppiche]');
    const wrapper = navigation?.closest('.shopify-section');
    if (!wrapper) return;
    try {
      const { sectionRenderer } = await import('@theme/section-renderer');
      await sectionRenderer.renderSection(wrapper.id.replace('shopify-section-', ''));
    } catch {
      window.location.reload();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-start-kategorien"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var list = document.getElementById('tp-kat-list');
    var dots = document.querySelectorAll('#tp-kat-dots i');
    if (!list || !dots.length) return;
    // Der automatische Fokusscroll kann zwischen zwei Snap-Punkten enden.
    // Die aktive Karte soll samt Titel und Unterzeile voll sichtbar sein.
    list.addEventListener('focusin', function (event) {
      var card = event.target.closest('.tp-kat__card');
      if (!card || list.scrollWidth <= list.clientWidth) return;
      requestAnimationFrame(function () {
        if (document.activeElement === card) {
          card.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'auto' });
        }
      });
    });
    list.addEventListener('scroll', function () {
      var first = list.firstElementChild;
      if (!first) return;
      var w = first.offsetWidth + 12;
      var i = Math.round(list.scrollLeft / w);
      dots.forEach(function (d, j) { d.classList.toggle('on', j === i); });
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-start-kontakt"] && !Shopify.designMode) return;
  try {
    
  /* Herkunft fuer die Anfrage-Mail (Werkbank w-030): kam der Besuch ueber eine
     Anzeige oder einen Kampagnenlink? Gelesen wird nur die Adresse dieser Seite,
     gespeichert wird nichts auf dem Geraet; Klick-IDs (gclid ...) gehen nicht mit,
     nur ihr Kanal. Das Control Center zaehlt "Anzeige" als Quelle Werbung. */
  (function () {
    var felder = document.querySelectorAll('[data-tp-herkunft]');
    if (!felder.length) return;
    var p = new URLSearchParams(window.location.search);
    var quelle = (p.get('utm_source') || '').slice(0, 40);
    var medium = (p.get('utm_medium') || '').toLowerCase();
    var kampagne = (p.get('utm_campaign') || '').slice(0, 60);
    var text = '';
    if (p.get('gclid') || p.get('gbraid') || p.get('wbraid')) text = 'Google-Anzeige';
    else if (p.get('msclkid')) text = 'Microsoft-Anzeige';
    else if (/^(cpc|ppc|paid|paid_?social|display|ads?)$/.test(medium)) text = 'Anzeige (' + (quelle || 'unbekannt') + ')';
    else if (p.get('fbclid')) text = 'Link von Facebook/Instagram';
    else if (quelle) text = 'Link (' + quelle + ')';
    if (kampagne) text += (text ? ' · ' : '') + 'Kampagne ' + kampagne;
    if (!text) return;
    felder.forEach(function (f) { f.value = text; });
  })();

  (function () {
    var t = document.querySelector('[data-tp-kon-toggle]');
    if (!t) return;
    var card = t.closest('.tp-kon__card--form');
    if (card && card.querySelector('.tp-kon__ok, .tp-kon__err')) card.classList.add('tp-kon__card--offen');
    function oeffnen() {
      card.classList.add('tp-kon__card--offen');
      t.setAttribute('aria-expanded', 'true');
    }
    t.addEventListener('click', function () {
      oeffnen();
      var first = card.querySelector('input[type=text]');
      if (first) first.focus();
    });
    /* Buttons "Verlegung anfragen" auf Serviceseiten springen auf #tp-anfrage:
       am Telefon dann gleich das Formular zeigen statt nur den Aufklapp-Knopf. */
    function perAnker() {
      if (window.location.hash !== '#tp-anfrage') return;
      oeffnen();
      // Die Karte fokussieren, ohne die Bildschirmtastatur zu oeffnen.
      card.focus({ preventScroll: true });
      // Der native Ankersprung kann noch mit der eingeklappten Hoehe rechnen.
      // Nach dem Layout neu ausrichten; instant beendet dabei einen laufenden
      // nativen Smoothscroll. Der CSS-Scrollabstand haelt den Header frei.
      window.requestAnimationFrame(function () {
        if (window.location.hash !== '#tp-anfrage' || !card.isConnected) return;
        card.scrollIntoView({ block: 'start', behavior: 'instant' });
      });
    }
    perAnker();
    window.addEventListener('hashchange', perAnker);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-start-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function liste(t) {
      var key = t.getAttribute('data-tp-target');
      if (!key) return null;
      return document.querySelector('.shopify-section[id$="__' + key + '"]') || document.getElementById('shopify-section-' + key);
    }
    document.querySelectorAll('[data-tp-tabs]').forEach(function (root) {
      var alle = Array.prototype.slice.call(root.querySelectorAll('.tp-tabs__tab'));
      if (!alle.length) return;
      // Nur Reiter, deren Liste wirklich Karten zeigt (#69). Im Theme-Editor
      // bleiben alle stehen, damit jede Liste auswaehlbar bleibt.
      var editor = !!(window.Shopify && window.Shopify.designMode);
      var tabs = alle.filter(function (t) {
        var sec = liste(t);
        var voll = !!(sec && sec.querySelector('.resource-list__item'));
        if (!voll && !editor) {
          t.hidden = true;
          t.setAttribute('aria-selected', 'false');
          if (sec) sec.hidden = true;
        }
        return voll || editor;
      });
      if (!tabs.length) {
        var abschnitt = root.closest('.shopify-section') || root;
        abschnitt.hidden = true;
        abschnitt.style.display = 'none';
        return;
      }
      function show(active) {
        tabs.forEach(function (t) {
          var on = t === active;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
          var sec = liste(t);
          if (!sec) return;
          sec.hidden = !on;
          // Die CSS-Regel oben blendet die Listen der uebrigen Reiter aus, bis sie aktiv sind
          if (on) sec.setAttribute('data-tp-tab-aktiv', '');
          else sec.removeAttribute('data-tp-tab-aktiv');
        });
      }
      tabs.forEach(function (t) { t.addEventListener('click', function () { show(t); }); });
      // Pfeiltasten, Pos1 und Ende wie bei role=tablist ueblich (Audit B-47)
      tabs.forEach(function (t, i) {
        t.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          else if (e.key === 'Home') next = tabs[0];
          else if (e.key === 'End') next = tabs[tabs.length - 1];
          if (!next) return;
          e.preventDefault();
          show(next);
          next.focus();
        });
      });
      show(tabs[0]);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-sticky-kontakt"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.getElementById('tp-sticky');
    if (!bar) return;
    var kontakt = document.getElementById('tp-kontakt');
    function onScroll() {
      var past = window.scrollY > 600;
      var near = false;
      if (kontakt) { var r = kontakt.getBoundingClientRect(); near = r.top < window.innerHeight && r.bottom > 0; }
      bar.classList.toggle('tp-sticky--show', past && !near);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-treppen-ausfuehrung"] && !Shopify.designMode) return;
  try {
    
  /* Wisch-Hinweis nur zeigen, wenn die Tabelle wirklich breiter ist als ihr Kasten. */
  (function () {
    function pruefen() {
      document.querySelectorAll('[data-tp-matrix-scroll]').forEach(function (box) {
        var hinweis = box.parentNode && box.parentNode.querySelector('[data-tp-wisch]');
        if (hinweis) hinweis.hidden = box.scrollWidth <= box.clientWidth + 1;
      });
    }
    pruefen();
    window.addEventListener('resize', pruefen);
    document.addEventListener('shopify:section:load', pruefen);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-widerruf"] && !Shopify.designMode) return;
  try {
    
  /* Widerrufsfunktion: zwei Schritte, Versand an die Web-App (POST,
     x-www-form-urlencoded = einfache CORS-Anfrage ohne Preflight). */
  if (!customElements.get('tp-widerruf')) {
    customElements.define('tp-widerruf', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-schritt="1"]');
        this.s2 = this.querySelector('[data-schritt="2"]');
        this.s3 = this.querySelector('[data-schritt="3"]');
        this.form.addEventListener('submit', (e) => { e.preventDefault(); this.weiter(); });
        this.s2.querySelector('.tp-wr__zurueck').addEventListener('click', () => this.zeige(this.form));
        this.knopf = this.s2.querySelector('.tp-wr__bestaetigen');
        this.knopf.addEventListener('click', () => this.senden());
      }

      zeige(el) {
        [this.form, this.s2, this.s3].forEach((s) => { s.hidden = s !== el; });
        (el === this.form ? this.form.querySelector('input') : el).focus();
        el.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }

      fehler(el, text) {
        const f = el.querySelector('.tp-wr__fehler');
        f.textContent = text || '';
        f.hidden = !text;
      }

      daten() {
        const fd = new FormData(this.form);
        const d = {};
        fd.forEach((v, k) => { d[k] = String(v).trim(); });
        return d;
      }

      weiter() {
        const d = this.daten();
        const felder = this.form.querySelectorAll('input[required]');
        for (const f of felder) {
          f.value = f.value.trim();
          if (!f.checkValidity()) {
            this.fehler(this.form, 'Bitte füllen Sie „' + f.labels[0].textContent.replace('*', '').trim() + '“ korrekt aus.');
            f.focus();
            return;
          }
        }
        this.fehler(this.form, '');
        const liste = this.s2.querySelector('.tp-wr__zusammenfassung');
        liste.replaceChildren();
        [['Name', d.name], ['Bestellnummer', d.bestellnummer], ['E-Mail-Adresse', d.email],
         ['Bestelldatum', d.bestelldatum || '–'], ['Betroffene Artikel', d.artikel || 'gesamte Bestellung']]
          .forEach(([k, v]) => {
            const dt = document.createElement('dt'); dt.textContent = k;
            const dd = document.createElement('dd'); dd.textContent = v;
            liste.append(dt, dd);
          });
        this.fehler(this.s2, '');
        // Je Zusammenfassung eine Kennung: ein erneuter Klick nach Netzabbruch erzeugt keinen zweiten Widerruf
        this.kennung = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now()) + '-' + Math.random().toString(36).slice(2, 10);
        this.zeige(this.s2);
      }

      async senden() {
        const endpoint = this.dataset.endpoint;
        const mail = 'kontakt@teppich-paradies.net';
        if (!endpoint) {
          this.fehler(this.s2, 'Das Formular ist gerade nicht erreichbar. Bitte erklären Sie Ihren Widerruf per E-Mail an ' + mail + '.');
          return;
        }
        const d = this.daten();
        d.bestaetigt = 'ja';
        d.id = this.kennung;
        this.knopf.disabled = true;
        this.knopf.textContent = 'Wird gesendet …';
        try {
          const antwort = await fetch(endpoint, { method: 'POST', body: new URLSearchParams(d) });
          const r = await antwort.json();
          if (!r.ok) {
            this.fehler(this.s2, r.meldung || 'Bitte prüfen Sie Ihre Angaben (Name, Bestellnummer, E-Mail-Adresse) oder erklären Sie Ihren Widerruf per E-Mail an ' + mail + '.');
            return;
          }
          this.s3.querySelector('.tp-wr__eingang').textContent =
            'Eingegangen am ' + r.datum + ' um ' + r.uhrzeit + ' Uhr · Vorgangsnummer ' + r.ref;
          this.s3.querySelector('.tp-wr__mailinfo').textContent = r.mail
            ? 'Eine Eingangsbestätigung mit Inhalt, Datum und Uhrzeit haben wir an ' + d.email + ' gesendet.'
            : 'Die Bestätigungs-E-Mail an ' + d.email + ' konnte nicht verschickt werden. Ihr Widerruf ist trotzdem eingegangen; wir melden uns.';
          this.zeige(this.s3);
        } catch (err) {
          this.fehler(this.s2, 'Senden hat nicht geklappt. Bitte versuchen Sie es erneut oder erklären Sie Ihren Widerruf per E-Mail an ' + mail + '.');
        } finally {
          this.knopf.disabled = false;
          this.knopf.textContent = 'Widerruf bestätigen';
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-zubehoer-produkte"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Teppich-Gruppen: Reihen mit data-tp-reihe-nachladen zeigen nur die ersten Karten.
    // Die vollstaendigen Reihen kommen aus der Vorlage collection.teppiche-reihen (eine
    // Anfrage fuer alle Reihen) und ersetzen den Kartenbereich. Bei einem Fehler bleiben
    // ein erreichbarer Wiederholungsversuch und die regulaere paginierte Liste stehen.
    var laden = null;

    function holen(url) {
      if (!laden) {
        laden = fetch(url, { credentials: 'same-origin' })
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.text();
          })
          .then(function (text) {
            return new DOMParser().parseFromString(text, 'text/html');
          });
        laden.catch(function () { laden = null; });
      }
      return laden;
    }

    function linkFokussieren(bereich, href) {
      var links = Array.prototype.slice.call(bereich.querySelectorAll('a[href]'));
      if (href) {
        links = links.filter(function (link) { return link.getAttribute('href') === href; }).concat(
          links.filter(function (link) { return link.getAttribute('href') !== href; })
        );
      }
      for (var i = 0; i < links.length; i++) {
        // Horizon umschliesst Karten mit display: contents-Links. Diese haben
        // kein eigenes Layoutrechteck und .focus() bleibt dort wirkungslos.
        var sichtbar = Array.prototype.some.call(links[i].getClientRects(), function (rect) {
          return rect.width > 0 && rect.height > 0;
        });
        if (!sichtbar) continue;
        links[i].focus({ preventScroll: true });
        if (document.activeElement === links[i]) return true;
      }
      return false;
    }

    function einsetzen(doc) {
      var reihen = Array.prototype.slice.call(document.querySelectorAll('[data-tp-reihe-nachladen]'));
      // Reihen ueber dem Blick wachsen, der Blick soll stehen bleiben. Chrome und Firefox
      // verankern selbst (overflow-anchor); nur ohne diese Faehigkeit (Safari) von Hand,
      // sonst wuerde doppelt korrigiert.
      var vonHand = !(window.CSS && CSS.supports && CSS.supports('overflow-anchor', 'auto'));
      var anker = null;
      for (var i = 0; vonHand && i < reihen.length; i++) {
        if (reihen[i].getBoundingClientRect().bottom > 0) { anker = reihen[i]; break; }
      }
      var ankerOben = anker ? anker.getBoundingClientRect().top : 0;
      reihen.forEach(function (reihe) {
        var gruppe = reihe.getAttribute('data-tp-reihe-gruppe');
        var neu = doc.querySelector('[data-tp-reihe-gruppe="' + gruppe + '"] [data-tp-reihe-karten]');
        var alt = reihe.querySelector('[data-tp-reihe-karten]');
        if (!neu || !alt) return;
        var offen = reihe.classList.contains('is-offen') || reihe.hasAttribute('data-tp-reihe-oeffnen');
        var fokus = document.activeElement;
        var imKartenbereich = fokus && alt.contains(fokus);
        var fokusLink = imKartenbereich && fokus.closest('a[href]');
        var href = fokusLink && fokusLink.getAttribute('href');
        var mehrFokus = imKartenbereich && fokus.closest('[data-tp-gruppe-mehr]');
        var ersatz = reihe.querySelector('[data-tp-reihe-ersatz]');
        var retryFokus = ersatz && ersatz.contains(fokus);
        // Kartenbilder vor dem Einsetzen vorbereiten (Rundgang 2026-10-26): Am Handy
        // kamen je Reihe die vier sichtbaren Bilder zuerst in 1440 px und danach
        // noch einmal in 600 px, zusammen rund 7 MB.
        // 1. Ohne "auto" in sizes: importierte Bilder waehlen ihre Quelle, bevor das
        //    Layout steht, "auto" fiel dabei auf die volle Bildschirmbreite zurueck.
        //    Der Rueckfallwert danach (mobil 50vw, ab 750 px 25vw) passt zu den Reihen.
        // 2. src und srcset ans Ende: importNode kopiert die Attribute der Reihe nach.
        //    Stand srcset vor loading und sizes, begann Chrome schon beim Kopieren
        //    einen Abruf in 1440 px (ohne sizes = 100vw), den es gleich wieder abbrach.
        Array.prototype.forEach.call(neu.querySelectorAll('img[srcset]'), function (img) {
          var sizes = img.getAttribute('sizes') || '';
          if (/^auto\s*,/.test(sizes)) img.setAttribute('sizes', sizes.replace(/^auto\s*,\s*/, ''));
          ['src', 'srcset'].forEach(function (name) {
            var wert = img.getAttribute(name);
            if (wert === null) return;
            img.removeAttribute(name);
            img.setAttribute(name, wert);
          });
        });
        alt.replaceWith(document.importNode(neu, true));
        reihe.removeAttribute('data-tp-reihe-nachladen');
        reihe.removeAttribute('data-tp-reihe-oeffnen');
        if (ersatz) ersatz.hidden = true;
        if (offen) {
          reihe.classList.add('is-offen');
          var knopf = reihe.querySelector('[data-tp-gruppe-mehr]');
          if (knopf) knopf.setAttribute('aria-expanded', 'true');
        }
        if (imKartenbereich || retryFokus) {
          var neuerBereich = reihe.querySelector('[data-tp-reihe-karten]');
          var fokussiert = href && linkFokussieren(neuerBereich, href);
          // Der mobile Mehrknopf ist nach dem Oeffnen verborgen: zur ersten
          // neu sichtbaren Karte springen, statt einen unsichtbaren Knopf zu fokussieren.
          if (!fokussiert && mehrFokus && !offen) {
            var mehr = neuerBereich.querySelector('[data-tp-gruppe-mehr]');
            if (mehr) { mehr.focus({ preventScroll: true }); fokussiert = document.activeElement === mehr; }
          }
          if (!fokussiert && offen && (mehrFokus || retryFokus)) {
            var karten = neuerBereich.querySelectorAll('.resource-list__item');
            if (karten[4]) fokussiert = linkFokussieren(karten[4]);
          }
          if (!fokussiert) linkFokussieren(neuerBereich);
        }
      });
      if (anker && anker !== reihen[0]) {
        var versatz = anker.getBoundingClientRect().top - ankerOben;
        if (Math.abs(versatz) > 1) window.scrollBy(0, versatz);
      }
    }

    function start() {
      var erste = document.querySelector('[data-tp-reihe-nachladen]');
      if (!erste) return Promise.resolve();
      return holen(erste.getAttribute('data-tp-reihe-nachladen')).then(einsetzen).catch(function () {
        document.querySelectorAll('[data-tp-reihe-nachladen]').forEach(function (reihe) {
          var fehler = reihe.querySelector('[data-tp-reihe-fehler]');
          var erneut = reihe.querySelector('[data-tp-reihe-erneut]');
          if (fehler) fehler.hidden = false;
          if (erneut) erneut.hidden = false;
        });
      });
    }

    function imLeerlauf() {
      if ('requestIdleCallback' in window) window.requestIdleCallback(start, { timeout: 2000 });
      else setTimeout(start, 300);
    }
    if (document.readyState === 'complete') imLeerlauf();
    else window.addEventListener('load', imLeerlauf);

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-tp-reihe-erneut]')) { start(); return; }
      var knopf = event.target.closest('[data-tp-gruppe-mehr]');
      if (!knopf) return;
      var reihe = knopf.closest('.tp-zubehoer-produkte--teppich-gruppe');
      if (!reihe) return;
      if (reihe.hasAttribute('data-tp-reihe-nachladen')) {
        // Erst oeffnen, wenn die weiteren Karten wirklich da sind. Sonst verbirgt
        // Mobile den noch fokussierten Mehrknopf bereits waehrend des Wartens.
        reihe.setAttribute('data-tp-reihe-oeffnen', '1');
        start();
        return;
      }
      var fokusAmKnopf = document.activeElement === knopf;
      reihe.classList.add('is-offen');
      knopf.setAttribute('aria-expanded', 'true');
      if (fokusAmKnopf) {
        var karten = reihe.querySelectorAll('.resource-list__item');
        if (karten[4]) linkFokussieren(karten[4]);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
